import React, { useState, useContext } from 'react';
import AppContext from '../../contexts/AppContext';
import { Flag, Lock, TrendingUp, Sparkles } from 'lucide-react';
import * as firestoreService from '../../services/firestoreService';

const CaddieProGate = () => {
  const { currentUser, setCurrentUser, showAlert } = useContext(AppContext);
  const [starting, setStarting] = useState(false);
  const [showTrialConfirm, setShowTrialConfirm] = useState(false);

  const handleStartTrial = async () => {
    setStarting(true);
    try {
      const trialStartDate = new Date().toISOString();
      await firestoreService.updateUser(currentUser.id, { trialStartDate, trialUsed: true });
      setCurrentUser({ ...currentUser, trialStartDate, trialUsed: true });
    } catch (err) {
      console.error('Error starting trial:', err);
      showAlert('Failed to start trial. Please try again.', 'Error');
    }
    setStarting(false);
    setShowTrialConfirm(false);
  };

  if (showTrialConfirm) {
    return (
      <div className="max-w-md mx-auto p-6">
        <div className="bg-gradient-to-b from-gray-900 to-black border border-gray-700 rounded-2xl p-8">
          <h2 className="text-xl font-bold text-white mb-2">Before you start your trial</h2>
          <p className="text-gray-400 text-sm mb-5">Here's what each Caddie Pro feature needs to work at its best:</p>
          <div className="space-y-4 mb-5">
            <div className="bg-gray-800/60 rounded-xl p-4">
              <div className="flex items-start space-x-3">
                <span className="text-xl leading-none mt-0.5">🧠</span>
                <div>
                  <p className="text-white font-semibold text-sm">AI Coaching Tips</p>
                  <p className="text-gray-400 text-xs mt-1">Requires at least <span className="text-yellow-400 font-medium">3 completed games</span> so the AI has enough data to analyse your game.</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-800/60 rounded-xl p-4">
              <div className="flex items-start space-x-3">
                <span className="text-xl leading-none mt-0.5">⛳</span>
                <div>
                  <p className="text-white font-semibold text-sm">Course Recommendations</p>
                  <p className="text-gray-400 text-xs mt-1">Requires your <span className="text-yellow-400 font-medium">location</span> (set in your profile or entered at search time). Your <span className="text-yellow-400 font-medium">handicap</span> and <span className="text-yellow-400 font-medium">skill level</span> personalise the AI results — both can be set in your profile.</p>
                </div>
              </div>
            </div>
          </div>
          <p className="text-gray-500 text-xs text-center mb-6">You can start playing and completing games right away — your Caddie Pro features will unlock as you meet each requirement.</p>
          <button
            onClick={handleStartTrial}
            disabled={starting}
            className="w-full bg-yellow-600 text-white py-3 rounded-lg font-bold hover:bg-yellow-700 transition-colors disabled:opacity-50 mb-2"
          >
            {starting ? 'Starting...' : 'Start Trial'}
          </button>
          <button
            onClick={() => setShowTrialConfirm(false)}
            className="w-full text-gray-400 py-2 text-sm hover:text-white transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-6 text-center">
      <div className="bg-gradient-to-b from-gray-900 to-black border border-gray-700 rounded-2xl p-8">
        <div className="inline-block p-4 bg-yellow-600/20 rounded-full mb-4">
          <Lock className="w-10 h-10 text-yellow-500" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">Caddie Pro</h2>
        <p className="text-gray-400 mb-4">Unlock AI-powered coaching and course recommendations</p>
        <p className="text-3xl font-bold text-white mb-1">$2.95<span className="text-lg text-gray-400 font-normal">/month</span></p>
        <ul className="text-left text-sm text-gray-300 space-y-2 my-6">
          <li className="flex items-center space-x-2"><Sparkles className="w-4 h-4 text-yellow-500 flex-shrink-0" /><span>Personalized AI coaching tips</span></li>
          <li className="flex items-center space-x-2"><Flag className="w-4 h-4 text-yellow-500 flex-shrink-0" /><span>Personalized AI course recommendations</span></li>
          <li className="flex items-center space-x-2"><TrendingUp className="w-4 h-4 text-yellow-500 flex-shrink-0" /><span>Performance analysis from your rounds</span></li>
        </ul>
        <button
          onClick={() => showAlert('To upgrade to Caddie Pro, please contact support at support@loftgolf.app', 'Upgrade to Caddie Pro')}
          className="w-full bg-yellow-600 text-white py-3 rounded-lg font-bold hover:bg-yellow-700 transition-colors"
        >
          Upgrade to Caddie Pro
        </button>
        {!currentUser.trialUsed && (
          <div className="mt-3">
            <button
              onClick={() => setShowTrialConfirm(true)}
              className="w-full bg-gray-800 text-yellow-400 border border-yellow-600/40 py-3 rounded-lg font-bold hover:bg-gray-700 transition-colors"
            >
              Start a 30-day Trial
            </button>
            <p className="text-gray-500 text-xs mt-2">No credit card required</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CaddieProGate;
